import type { RefObject } from "react";
import { Button } from "@/components/ui/button";
import { TiptapEditor, type TiptapEditorRef } from "../TiptapEditor";

interface MessageEditorProps {
  editorRef: RefObject<TiptapEditorRef | null>;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * Inline edit form rendered in place of the message body when the viewer
 * triggers Edit. The parent loads the existing markdown into `editorRef`
 * after this component mounts (via `requestAnimationFrame`).
 */
export function MessageEditor({
  editorRef,
  onSave,
  onCancel,
}: MessageEditorProps) {
  return (
    <div className="bg-accent rounded px-2 py-1">
      <TiptapEditor
        ref={editorRef}
        compact
        autoFocus
        onSend={onSave}
        onEscape={onCancel}
        placeholder="Edit message..."
      />
      <div className="flex items-center gap-2 mt-1">
        <p className="text-[10px] text-muted-foreground/50">Enter to save</p>
        <Button
          type="button"
          variant="ghost"
          size="tiny"
          onClick={onCancel}
          className="h-auto px-0 text-[10px] text-muted-foreground/50 hover:text-muted-foreground"
        >
          Esc to cancel
        </Button>
      </div>
    </div>
  );
}
